import getFormatVersion from "./getFormatVersion";

// Removed hook as it caused render issues...
export default function getDisplayVersion(v: string, latestVersion: string): string {
  if (v.toLowerCase() === 'cloud') {
    return 'Cloud';
  }
  return v === latestVersion ? `${getFormatVersion(v)}` : v;
}
